import { useEffect } from "react";
import { motion } from "framer-motion";
import { Particles } from "@/components/Shared";

const fade = (delay, dur = 1.1) => ({
    initial: { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0 },
    transition: { delay, duration: dur, ease: [0.22, 1, 0.36, 1] },
});

export default function Intro({ onDone }) {
    useEffect(() => {
        const t = setTimeout(onDone, 5600);
        return () => clearTimeout(t);
    }, [onDone]);

    return (
        <motion.div
            className="fixed inset-0 z-[120] flex items-center justify-center bg-[#100206] overflow-hidden"
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            data-testid="intro-overlay"
            onClick={onDone}
        >
            <Particles density={90} />
            <svg className="absolute inset-0 m-auto h-[80vh] max-w-full opacity-70" viewBox="0 0 400 460" fill="none" aria-hidden="true">
                <motion.path d="M60 440 V190 Q60 40 200 40 Q340 40 340 190 V440" stroke="var(--gold)" strokeWidth="1.4"
                    initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 2.2, ease: "easeInOut" }} />
                <motion.path d="M95 440 V200 Q95 80 200 80 Q305 80 305 200 V440" stroke="var(--bronze)" strokeWidth="0.9"
                    initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 2.2, delay: 0.4, ease: "easeInOut" }} />
                <motion.path d="M130 440 V210 Q130 120 200 120 Q270 120 270 210 V440" stroke="var(--gold)" strokeWidth="0.5"
                    initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 2, delay: 0.8, ease: "easeInOut" }} />
            </svg>
            <div className="relative text-center px-6">
                <motion.img src="/emblem.png" alt="Startup MahaBazaar emblem" className="mx-auto w-14 md:w-20 mb-8"
                    initial={{ opacity: 0, scale: 0.7, filter: "blur(8px)" }}
                    animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                    transition={{ delay: 1.3, duration: 1.3, ease: [0.22, 1, 0.36, 1] }} />
                <motion.p {...fade(1.9)} className="text-[0.6rem] md:text-xs tracking-[0.7em] uppercase text-[var(--gold)]">
                    Startup
                </motion.p>
                <motion.h1 {...fade(2.2)} className="font-display font-semibold gold-text text-4xl md:text-7xl tracking-wide mt-3">
                    MAHABAZAAR
                </motion.h1>
                <motion.div {...fade(2.7)} className="flex items-center justify-center gap-5 mt-4">
                    <span className="h-px w-12 md:w-20 bg-gradient-to-r from-transparent to-[var(--gold)]" />
                    <span className="font-display text-xl md:text-3xl tracking-[0.5em] text-[var(--ivory)]">2027</span>
                    <span className="h-px w-12 md:w-20 bg-gradient-to-l from-transparent to-[var(--gold)]" />
                </motion.div>
                <motion.p {...fade(3.2)} className="font-display italic text-base md:text-xl text-[var(--champagne)]/90 mt-6">
                    Bazaar of Ideas, Innovation &amp; Impact
                </motion.p>
                <motion.p {...fade(3.7)} className="text-[0.58rem] md:text-[0.66rem] tracking-[0.42em] uppercase text-muted-luxe mt-5">
                    29–31 January 2027 · MSIT &amp; MSI, New Delhi
                </motion.p>
            </div>
            <motion.button
                {...fade(4)}
                onClick={(e) => { e.stopPropagation(); onDone(); }}
                data-testid="intro-skip-btn"
                className="absolute bottom-8 right-8 text-[0.6rem] tracking-[0.36em] uppercase text-muted-luxe hover:text-[var(--champagne)] transition-colors"
            >
                Skip → Enter the Bazaar
            </motion.button>
        </motion.div>
    );
}
